import type { FC } from 'react';
import { useContext, createContext, useMemo } from 'react';

import { useWindowSize } from '~/hooks';

interface WindowDimensionsContextProps {
  windowHeight: number;
  windowWidth: number;
  syncSizes: () => void;
}

export const WindowDimensionsContext = createContext<WindowDimensionsContextProps | undefined>(
  undefined,
);

export const WindowDimensionsProvider: FC = ({ children }) => {
  const { height: windowHeight, width: windowWidth, sync: syncSizes } = useWindowSize();

  const value: WindowDimensionsContextProps = useMemo(
    () => ({
      windowHeight,
      windowWidth,
      syncSizes,
    }),
    [windowHeight, windowWidth, syncSizes],
  );

  return (
    <WindowDimensionsContext.Provider value={value}>{children}</WindowDimensionsContext.Provider>
  );
};

export const useWindowDimensionsContext = () => {
  const context = useContext(WindowDimensionsContext);

  if (context) {
    return context;
  }
  throw new Error('WindowDimensionsContext value must be set.');
};
